import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/nav1.png'
import _imports_1 from '../assets/img/nav2.png'
import _imports_2 from '../assets/img/nav3.png'
import _imports_3 from '../assets/img/logo.png'
import _imports_4 from '../assets/img/close_poster.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-70ccfb0c")

_pushScopeId("data-v-70ccfb0c")
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "两会100问题",
  style: {"animation-delay":"0.5s"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "我要提建议",
  style: {"animation-delay":"1s"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "logo",
  alt: ""
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "poster"
}
const _hoisted_7 = { class: "shadow" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "content" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Xiaofeng = _resolveComponent("Xiaofeng")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Xiaofeng),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "chat" }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "propose" }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode("img", {
        src: _imports_2,
        alt: "抽取盲盒",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePoster && _ctx.handlePoster(...args))),
        style: {"animation-delay":"1.5s"}
      })
    ]),
    _hoisted_5,
    (_ctx.poster)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("img", {
            src: _ctx.poster,
            class: "img",
            alt: ""
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.text), 1),
          _hoisted_8,
          _createVNode("div", {
            class: "share",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleShare && _ctx.handleShare(...args)))
          }, "分享海报"),
          _createVNode("img", {
            src: _imports_4,
            class: "close",
            alt: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.poster = ''))
          })
        ]))
      : _createCommentVNode("", true)
  ]))
})